export interface RequestLockResult<T> {
  executed: boolean;
  value?: T;
}

export function createRequestLock(
  onChange: (pendingKeys: Set<string>) => void = () => undefined
) {
  const pendingKeys = new Set<string>();
  const emitChange = () => onChange(new Set(pendingKeys));

  return {
    isPending(key: string) {
      return pendingKeys.has(key);
    },
    async run<T>(
      key: string,
      action: () => Promise<T>
    ): Promise<RequestLockResult<T>> {
      if (pendingKeys.has(key)) {
        return { executed: false };
      }

      pendingKeys.add(key);
      emitChange();
      try {
        return { executed: true, value: await action() };
      } finally {
        pendingKeys.delete(key);
        emitChange();
      }
    },
  };
}
